import React, { useState } from 'react';
import {  Card, Button, Form , Alert} from 'react-bootstrap';
import PaiementVirementCotisation from './paiementVirementCotisation';
import axios from 'axios';
import PaiementRevolut from './paiementRevolut';

const PaiementCotisation = (props) => {
        const [typePaiement, setTypePaiement] = useState('')
        const [paiement, setPaiement] = useState(false)
        const [isLoading, setIsLoading] = useState(false)
        const [error, setError] = useState(false)

        const apiUrl = process.env.REACT_APP_API_URL;


        const handleSubmit = async (e) => {
            e.preventDefault();
            setIsLoading(true);
            setPaiement(false);
            
            try {
              await axios.post(`${apiUrl}/cotisation/paiement/joueur`, {
                idEquipe : props.userData.user.donnée.results[0].id_equipe,
                idJoueur : props.userData.user.donnée.results[0].id,
                typePaiement : typePaiement
              }, {
                withCredentials: true
              });
          
              setError(null);
              setIsLoading(false);
              window.location.reload(); 
          
            } catch (error) {
              if (error.response.data.message) {
                setIsLoading(false)
                setError(error.response.data.message);
              } else {
                setIsLoading(false)
                setError(true);
              }
            }
          };


          if (isLoading) {
            return (
              <div className="centered-content">
                <img src="/img/logo.png" alt="Logo" className="centered-logo" />
                <br />
                <span className="loader"></span>
              </div>
            );
          }


    return (
        <>
        {paiement &&
        <>
            {typePaiement === 'virement' && <PaiementVirementCotisation handleSubmit={handleSubmit} userData={props.userData} cotisation={props.cotisation} setChangement={() => {setPaiement(false);}}/>}
            {typePaiement === 'revolut' && <PaiementRevolut handleSubmit={handleSubmit} userData={props.userData} cotisation={props.cotisation} setChangement={() => {setPaiement(false);}}/>}

        </>
        }
        {props.cotisation && props.cotisation.cotisationJoueur &&
                                <Card.Body>
                                    {error && <Alert variant="danger">{error}</Alert>}
                                    <br/>
                                    <Card.Title>Paiement de votre cotisation</Card.Title>
                                    <div className="mb-3">
                                        <label htmlFor="dateMax">Commentaire pour les joueurs (facultatif): </label>
                                        <Form.Control as="textarea" placeholder="Ajoutez un commentaire" disabled value={props.cotisation.cotisationJoueur[0].commentaireCotisation} rows={3} />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="cout">Coût :</label>
                                        <span className="ms-2">€</span>
                                        <input type="number" className="form-control" id="cout"  disabled value={props.cotisation.cotisationJoueur[0].prixCotisation}/>
                                    </div>
                                    <Form>
                                        <Form.Group>
                                            <Form.Label>Méthode de paiement</Form.Label>
                                            <Form.Control as="select" value={typePaiement} onChange={(e) => setTypePaiement(e.target.value)}>
                                                <option>Sélectionner un moyen de paiement</option>
                                                <option value='virement'>Virement bancaire</option>
                                                <option value='revolut'>Revolut</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <br/>
                                        <Button variant="primary" onClick={() => setPaiement(true)} disabled={typePaiement === ''} style={{backgroundColor:"#00E676", borderColor:'#00E676'}} >
                                            Effectuer le paiement
                                        </Button>
                                    </Form>
                                </Card.Body>
        }  
        </> 
    );
};

export default PaiementCotisation;
